import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  items: [],
  address: [],
  orderdetails: [],
  isPaid: false,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    listItems(state, action) {
      const { productId, name, quantity, price } = action.payload;

      const isExist = state.items.findIndex((a) => a.productId === productId);

      // console.log("isExist:" + isExist);

      if (isExist < 0) {
        // console.log("IF Triggered");
        state.items.push({ productId, name, quantity, price });
      } else {
        // console.log("else Triggered");
      }
    },

    listAddress(state, action) {
      const { address, city, postcode, country, telephone } = action.payload;
      state.address = [{ address, city, postcode, country, telephone }];
    },

    setIsPaid(state) {
      console.log("isPaid:" + state.isPaid);
      if (state.isPaid === false) {
        state.isPaid = true;
      } else {
        state.isPaid = false;
      }
    },

    listOrderDetails(state, action) {
      const {
        id,
        paymentmethod,
        totalprice,
        ispaid,
        paidat,
        isdelivered,
        deliveredat,
      } = action.payload;

      state.orderdetails = {
        id,
        paymentmethod,
        totalprice,
        ispaid,
        paidat,
        isdelivered,
        deliveredat,
      };
    },
  },
});
export const { listItems, listAddress, listOrderDetails, setIsPaid } =
  orderSlice.actions;
export default orderSlice.reducer;
